//charmhealth-production credentials
const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:029a86f7-8be7-4ccb-8903-4a6d7731b08c",
    // "aws_cognito_identity_pool_id": "us-east-1:f33995cf-7372-4e73-bc45-c5c34832bbe2",
    "aws_cognito_region": "us-east-1",
    // "aws_user_pools_id": "us-east-1_9SAOtUt9g",
    // "aws_user_pools_web_client_id": "3h6c776ga5etgibam22ml6pi63",
    "aws_user_pools_id": "us-east-1_cdww9atxQ",
    "aws_user_pools_web_client_id": "ec3p42st0u198isf1dd2i2n10",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};

export default awsmobile;